const platformCategoryOptions = [
  {
    name: 'WORKSTATION',
    label: 'Workstation',
    value: 'WORKSTATION'
  },
  {
    name: 'SERVER',
    label: 'Server',
    value: 'SERVER'
  }
];

const assetClassName = [
  {
    name: 'Mac Machine',
    label: 'Mac',
    value: 'Mac Machine'
  },
  {
    name: 'Windows Machine',
    label: 'Windows',
    value: 'Windows Machine'
  }
  // {
  //   name: 'Linux Machine',
  //   label: 'Linux',
  //   value: 'Linux Machine'
  // }
];

const assetStatusOptions = [
  {
    name: 'ONLINE',
    label: 'ONLINE',
    value: 'ONLINE'
  },
  {
    name: 'OFFLINE',
    label: 'OFFLINE',
    value: 'OFFLINE'
  }
];

const rebootOptions = [
  {
    name: 'true',
    label: 'true',
    value: 'true'
  },
  {
    name: 'false',
    label: 'false',
    value: 'false'
  }
];

const assetSmartStatusStatusOptions = [
  {
    name: 'OK',
    label: 'OK',
    value: 'OK'
  },
  {
    name: 'NOT_OK',
    label: 'NOT OK',
    value: 'NOT_OK'
  }
];

export {
  platformCategoryOptions,
  assetClassName,
  assetStatusOptions,
  assetSmartStatusStatusOptions,
  rebootOptions
};
